import React from "react";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  return (
    <nav className="navbar fixed-top navbar-expand-lg">
      <div className="container-fluid px-0">
        <NavLink className="navbar-brand" to="/">
          GAUSH
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav">
            <li className="nav-item">
              <NavLink className={`nav-link {(navData) => navData.isActive ? "navbar-active" : "" }`} to="/">
                HOME
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className={`nav-link {(navData) => navData.isActive ? "navbar-active" : "" }`} to="/music">
                MUSIC
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className={`nav-link {(navData) => navData.isActive ? "navbar-active" : "" }`} to="/videos">
                VIDEOS
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className={`nav-link {(navData) => navData.isActive ? "navbar-active" : "" }`} to="/lyrics">
                LYRICS
              </NavLink>
            </li>
          </ul>
          <a href="https://www.instagram.com/gaushmusic" target="_blank">
            <button className="contact-btn">INSTAGRAM</button>
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
